import type { HTMLProps } from "react";
import { useEffect, useRef } from "react";
import { Check, Minus } from "../Icon/Icon";
import styles from "./Checkbox.module.css";
import classNames from "classnames";

function Checkbox({
  indeterminate,
  className,
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <div className={styles.checkboxWrapper}>
      <input
        ref={ref}
        type="checkbox"
        className={classNames(className, styles.checkbox, {
          [styles.disabled]: rest.disabled,
        })}
        {...rest}
      />
      {rest.checked ? <Check className={styles.icon} size="xsmall" /> : null}
      {indeterminate ? <Minus className={styles.icon} size="xsmall" /> : null}
    </div>
  );
}

export default Checkbox;
